// extracted by mini-css-extract-plugin
module.exports = {"button":"_2s5fgYX0lLnrecZrUYQrIL"};